import { defineComponent as c, computed as d, openBlock as n, createElementBlock as i, unref as l, toDisplayString as u, createBlock as r, withCtx as b, resolveDynamicComponent as x } from "vue";
import { ElIcon as f } from "./index538.js";
import { paginationNextProps as k } from "./index745.js";
import { useLocale as g } from "./index597.js";
const C = ["disabled", "aria-label", "aria-disabled"], y = { key: 0 };
var E = /* @__PURE__ */ c({
  name: "ElPaginationNext",
  __name: "next",
  props: k,
  emits: ["click"],
  setup(s) {
    const t = s, { t: p } = g(), a = d(
      () => t.disabled || t.currentPage === t.pageCount || t.pageCount === 0
    );
    return (e, o) => (n(), i("button", {
      type: "button",
      class: "btn-next",
      disabled: a.value,
      "aria-label": e.nextText || l(p)("el.pagination.next"),
      "aria-disabled": a.value,
      onClick: o[0] || (o[0] = (m) => e.$emit("click", m))
    }, [
      e.nextText ? (n(), i(
        "span",
        y,
        u(e.nextText),
        1
        /* TEXT */
      )) : (n(), r(l(f), { key: 1 }, {
        default: b(() => [
          (n(), r(x(e.nextIcon)))
        ]),
        _: 1
        /* STABLE */
      }))
    ], 8, C));
  }
});
export {
  E as default
};
